import { Pawn } from './pawn';
import { SkeletonAnimator } from '../animators/skeletonanimator';
import { VIRTUAL_FUNC } from '../constants';

export class SkelAnimPawn extends Pawn {
  skel: any;
  skelWaiters: any[];
  motionCache: any;
  activeMotions: any[];

  constructor() {
    super();

    this.skel = null;
    this.skelWaiters = [];
    this.motionCache = null;
    this.activeMotions = [];
  }

  _getMotionData(motionIdx: any, callback: Function): any {
    return VIRTUAL_FUNC(motionIdx, callback);
  }

  _setSkeleton(skelData: any) {
    this.skel = skelData.create(this.rootObj);

    // Reset the loaded motions if the skeleton changed...
    this.motionCache = {};
    this.activeMotions = [];

    // Let everyone waiting know!
    for (let i = 0; i < this.skelWaiters.length; ++i) {
      this.skelWaiters[i]();
    }
    this.skelWaiters = [];
  }

  _waitSkeleton(callback: Function) {
    if (this.skel) {
      callback();
    } else {
      this.skelWaiters.push(callback);
    }
  }

  _getMotion(motionIdx: any, callback: Function) {
    // We check the cache after the getMotionData to avoid synchronization
    //   issues from calling this method twice in a row for the same motion.
    this._getMotionData(motionIdx, (animData: any) => {
      this._waitSkeleton(() => {
        if (this.motionCache[motionIdx]) {
          callback(this.motionCache[motionIdx]);
          return;
        }

        const anim = new SkeletonAnimator(this.skel, animData);
        this.motionCache[motionIdx] = anim;
        callback(anim);
      });
    });
  }

  playMotion(motionIdx: any, timeScale: any, loop: any, callback?: Function, shouldPlay?: () => boolean) {
    this._getMotion(motionIdx, (anim: any) => {
      if (shouldPlay && !shouldPlay()) return;
      const activeIdx = this.activeMotions.indexOf(anim);
      if (activeIdx !== -1) {
        this.activeMotions.splice(activeIdx, 1);
      }

      anim.timeScale = timeScale;
      anim.loop = loop;
      if (!anim.isPlaying || anim.isPaused) {
        anim.play(0, 0);
      }

      // If no motions were previously playing, immediately activate this one.
      if (this.activeMotions.length === 0) {
        anim.weight = 1;
      }

      this.activeMotions.unshift(anim);

      anim.clearEventListeners();
      if (callback) {
        callback(anim);
      }
    });
  }

  update(delta: any) {
    // Update Animation Blending
    const blendWeightDelta = 6 * delta;
    if (this.activeMotions.length >= 1) {
      const activeMotion = this.activeMotions[0];
      if (activeMotion.weight < 1) {
        activeMotion.weight += blendWeightDelta;
        if (activeMotion.weight > 1) {
          activeMotion.weight = 1;
        }
      }

      for (let i = 1; i < this.activeMotions.length; ++i) {
        const motion = this.activeMotions[i];
        motion.weight -= blendWeightDelta;

        // If we're done blending away, stop the motion and remove
        //  it from the list of motions.
        if (motion.weight <= 0) {
          motion.stop();
          this.activeMotions.splice(i, 1);
          --i;
        }
      }
    }

    return super.update(delta);
  }
}
